<nz-spin [nzSpinning]="loading">
    <div class="mb-2 mt-3">
        @if (signableDocumentFiles.length > 1) {
            <span class="ml-2 mr-2">Izvēlēti {{ setOfCheckedFiles.size }} faili</span>
        }
        @if (signableDocumentFiles.length > 1) {
            <cl-e-sign
                class="ml-2"
                [disabled]="setOfCheckedFiles.size < 2"
                [files]="converDocumentFileSetToFileArray(setOfCheckedFiles)"
                [signableFileType]="ESignatureSignableFileTypes.DOCUMENT"
                [mergeMode]="true"
                [documentId]="document.id"
            ></cl-e-sign>
        }
        @if (signableDocumentFiles.length > 1) {
            <cl-e-sign
                class="ml-2"
                [disabled]="setOfCheckedFiles.size < 2"
                [files]="converDocumentFileSetToFileArray(setOfCheckedFiles)"
                [signableFileType]="ESignatureSignableFileTypes.DOCUMENT"
                [mergeMode]="false"
                [documentId]="document.id"
            ></cl-e-sign>
        }
        @if (signableDocumentFiles.length > 1) {
            <button
                class="ml-2"
                [disabled]="setOfCheckedFiles.size < 2"
                nz-button
                nz-tooltip
                nzType="info"
                (click)="configureSelectedDocumentFileSigners()"
            >
                <span nz-icon nzType="edit" nzTheme="outline"></span> Labot parakstītājus
            </button>
        }
        @if (document.documentFiles.length > 1) {
            <button class="ml-2" nz-button nz-tooltip nzType="info" (click)="downloadAll()">
                <span nz-icon nzType="download" nzTheme="outline"></span> Lejupielādēt visus
            </button>
        }
    </div>
    <div class="w-full table-container">
        <nz-table #documentFilesTable nzSize="small" [nzData]="document?.documentFiles" [nzFrontPagination]="false">
            <thead>
                <tr>
                    @if (signableDocumentFiles.length > 1) {
                        <th
                            nzWidth="10%"
                            [nzChecked]="allSelectedChecked"
                            [nzIndeterminate]="allSelectedIndeterminate"
                            nzLabel="Izvēlēties visus"
                            (nzCheckedChange)="onAllChecked($event)"
                        ></th>
                    } @else {
                        <th nzWidth="5%"></th>
                    }
                    <th class="text-center break-text" nzBreakWord nzWidth="40%" [nzSortFn]="sortByDocumentFileOriginalName">Dokumenta fails</th>
                    @if (isEditMode && visibleColumns.includes('clientSignedTimestamp')) {
                        <th nzWidth="10%" class="text-center" [nzSortFn]="sortByDocumentFileClientSignedTimestamp">Klients parakstījis</th>
                    }
                    @if (isEditMode && visibleColumns.includes('metrumSignedTimestamp')) {
                        <th nzWidth="10%" class="text-center" [nzSortFn]="sortByDocumentFileMetrumSignedTimestamp">Metrum parakstījis</th>
                    }
                    @if (canEditFields && visibleColumns.includes('isSignableByClient')) {
                        <th class="text-center" nzWidth="10%" [nzSortFn]="sortByDocumentFileIsSignableByClient">Klientam jāparaksta</th>
                    }
                    @if (canEditFields && visibleColumns.includes('isSignableByMetrum')) {
                        <th class="text-center" nzWidth="10%" [nzSortFn]="sortByDocumentFileIsSignableByMetrum">Metrum jāparaksta</th>
                    }
                    <th class="text-center" nzWidth="10%"></th>
                </tr>
            </thead>
            <tbody>
                <ng-container>
                    @for (documentFile of documentFilesTable.data; track documentFile.id; let i = $index) {
                        <tr>
                            @if (signableDocumentFiles.length > 1 && documentFile.isSignableByMetrum) {
                                <td [nzChecked]="setOfCheckedFiles.has(documentFile)" (nzCheckedChange)="onItemChecked(documentFile, $event)"></td>
                            } @else {
                                <td></td>
                            }
                            <td>
                                <cl-file-download-link
                                    (downloadClicked)="downloadDocumentFile(documentFile)"
                                    [fileName]="documentFile.file.originalName"
                                    [showIcon]="false"
                                    [breakText]="false"
                                ></cl-file-download-link>
                                <cl-document-file-preview [documentId]="documentFile.documentId" [documentFileId]="documentFile.id" [fileName]="documentFile.file.originalName"></cl-document-file-preview>
                            </td>
                            @if (isEditMode && visibleColumns.includes('clientSignedTimestamp')) {
                                <td>
                                    {{ documentFile.clientSignedTimestamp ? (documentFile.clientSignedTimestamp | date: dateTimeFormat) : '-' }}
                                </td>
                            }
                            @if (isEditMode && visibleColumns.includes('metrumSignedTimestamp')) {
                                <td>
                                    {{ documentFile.metrumSignedTimestamp ? (documentFile.metrumSignedTimestamp | date: dateTimeFormat) : '-' }}
                                </td>
                            }
                            @if (canEditFields && visibleColumns.includes('isSignableByClient')) {
                                <td class="text-center">
                                    <label
                                        nz-checkbox
                                        [(ngModel)]="documentFile.isSignableByClient"
                                        (ngModelChange)="isSignableCheckedChanged(documentFile)"
                                        [disabled]="!documentIsSignable"
                                    ></label>
                                </td>
                            }
                            @if (canEditFields && visibleColumns.includes('isSignableByMetrum')) {
                                <td class="text-center">
                                    <label
                                        nz-checkbox
                                        [(ngModel)]="documentFile.isSignableByMetrum"
                                        (ngModelChange)="isSignableCheckedChanged(documentFile)"
                                        [disabled]="!documentIsSignable || documentFile.documentFileSigners.length > 0"
                                    ></label>
                                </td>
                            }
                            <td class="text-center">
                                <nz-flex nzGap="small">
                                    @if (isEditMode) {
                                        @if (documentFile.isSignableByMetrum && userHasToSignFile(documentFile)) {
                                            <cl-e-sign
                                                [files]="[documentFile.file]"
                                                [signableFileType]="ESignatureSignableFileTypes.DOCUMENT"
                                                [documentId]="documentFile.documentId"
                                            ></cl-e-sign>
                                        }
                                        @if (canEditFields) {
                                            @if (documentFile.isSignableByMetrum) {
                                                <button
                                                    nz-button
                                                    nz-tooltip
                                                    nzTooltipTitle="Labot dokumenta faila parakstītājus"
                                                    nzType="info"
                                                    (click)="editDocumentFileSigners(documentFile)"
                                                >
                                                    <span nz-icon nzType="edit" nzTheme="outline"></span>
                                                </button>
                                            }
                                            <button
                                                *hasPermission="[GroupPermissions.DOCUMENT_DELETE]"
                                                nz-button
                                                nzDanger
                                                (click)="deleteDocumentFile(documentFile, i)"
                                            >
                                                <i nz-icon nzType="delete"></i>
                                            </button>
                                        }
                                        <cl-info-button
                                            [id]="documentFile.id"
                                            [entityType]="EntityType.DocumentFile"
                                            (loadingChanged)="loading = $event"
                                        ></cl-info-button>
                                    }
                                </nz-flex>
                            </td>
                        </tr>
                    }
                </ng-container>
            </tbody>
        </nz-table>
    </div>
</nz-spin>
